module.exports = "<tags-input add-from-autocomplete-only=true display-property=full_name key-property=id ng-disabled=$ctrl.readOnly ng-model=$ctrl.authorTags placeholder=\"{{ 'Add an author...' | translate }}\" replace-spaces-with-dashes=false> <auto-complete source=$ctrl.authorSearch($query) min-length=1></auto-complete> </tags-input> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/authorlist/partial.html
// module id = 529
// module chunks = 0